import { Box } from '#/components/Box/Box';
import { LegacyButton } from '#/components/LegacyButton/LegacyButton';
import { H4 } from '#/components/Text/H4';

type Props = {
  onClick: () => void;
  toggled: boolean;
  index: number;
  title: string;
};

export function CmsAccordionBlockTitle({
  onClick,
  toggled,
  index,
  title,
}: Props) {
  return (
    <LegacyButton
      onClick={onClick}
      aria-controls={'accordionSection' + index}
      aria-expanded={toggled}
      width="100%"
    >
      <H4 m="0" py="30px">
        <Box
          display="flex"
          justifyContent="space-between"
          width="100%"
          alignItems="center"
          textAlign="left"
        >
          <span>{title}</span>
          <span>{toggled ? '-' : '+'}</span>
        </Box>
      </H4>
    </LegacyButton>
  );
}
